import { Injectable } from '@angular/core';
import { unregisterAppServiceWorker, getBranchName } from '@app/lib/utils/sw';

@Injectable({ providedIn: 'root' })
export class ServiceWorkerService {
  public async registerServiceWorker<T>(
    serviceWorkerConfig: T,
    scriptName: T | string,
  ): Promise<void> {
    if ('serviceWorker' in navigator) {
      await unregisterAppServiceWorker();

      const { scope, scriptURL } = this.getScoprAndURL<T>(scriptName);
      const registrationOptions: RegistrationOptions = {
        scope,
      };

      await navigator.serviceWorker.register(scriptURL, registrationOptions).then(
        (): void => {
          console.log(`${scriptName} Service worker registered`);
          navigator.serviceWorker.ready.then(
            (registration: ServiceWorkerRegistration): void => {
              registration.active.postMessage(serviceWorkerConfig);
            },
          );
        },
        (error): void => {
          console.error(
            `Service worker registration failed for ${scriptName}: ${error}`,
          );
        },
      );
    } else {
      console.error('Service workers are not supported.');
    }
  }

  public unregisterServiceWorkers<T>(workerName?: string): void {
    if ('serviceWorker' in navigator) {

      let scriptUrl: string;
      if (workerName) {
        const { scriptURL } = this.getScoprAndURL<T>(workerName);
        scriptUrl = scriptURL;
      }

      navigator.serviceWorker
        .getRegistrations()
        .then((registrations: ServiceWorkerRegistration[]) => {
          for (const registration of registrations) {
            if (!scriptUrl || (registration.active && registration.active.scriptURL === scriptUrl)) {
              registration
                .unregister()
                .then((isUnregistered: boolean) => {
                  if (isUnregistered) {
                    if (scriptUrl) {
                      console.log(`Service worker for ${scriptUrl} unregistered.`);
                    } else {
                      console.log('Service worker unregistered.');
                    }
                  }
                })
                .catch(() => {
                  console.error(scriptUrl ? `Service worker unregistration for ${scriptUrl} failed.` : 'Service worker unregistration failed.');
                });
            }
          }
        });
    }
  }

  public async clearCacheStorage(cacheName: string = ''): Promise<boolean[]> {
    return caches.keys().then((keys: string[]): Promise<boolean[]> => {
      return Promise.all(
        keys
          .filter(
            (key): boolean =>
              !cacheName || this.filterCacheWithName(key, cacheName),
          )
          .map((key: string): Promise<boolean> => caches.delete(key)),
      );
    });
  }

  private filterCacheWithName = (key: string, cacheName: string): boolean => {
    return key.includes(cacheName);
  }

  private getScoprAndURL<T>(scriptName: string | T) {
    const branchName: string = getBranchName(BRANCH_NAME);
    const locale: string = $localize.locale ? '/' + $localize.locale : '';
    const scope: string = `${branchName}${locale}/`;
    const scriptURL: string = `${scope}${scriptName}.sw.js`;
    return { scope, scriptURL };
  }
}
